import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
// Assuming external CSS for base styles (or using Tailwind utility classes)

const MenuDropdown = ({ isOpen, onClose, items, className }) => {
  const dropdownRef = useRef(null);

  console.log("call to menu dropdown. ")

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        onClose(); // Close the dropdown if a click is detected outside
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      ref={dropdownRef} 
      className={`menu-dropdown ${className || ""}`} 
      style={{
        // --- FIX FOR Z-INDEX AND POSITIONING ---
        border: "1px solid #374151", // Darker border for contrast on gray background
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
        minWidth: "150px",
        padding: "5px 0",
        position: "absolute", // IMPORTANT: Positions it relative to the parent with 'relative' positioning
        top: 0, // Position below the MoreButton
        left: -150, // Align to the right side of the MoreButton container
        zIndex: 2000, // IMPORTANT: High z-index to appear above all feed content
        background: "rgb(34, 31, 31)",
        color: "black",
        backdrop: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        transition: "0.2s ease"
      }}
    >
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {items.map((item, index) => (
          <li
            key={index}
            onClick={() => {
              item.action();
              // onClose(); // Let the action or the outside click handle closing, but good practice to close immediately.
            }}
            className={item.className || "menu-item"}
            style={{ 
              padding: "8px 12px", 
              cursor: "pointer", 
              fontSize: "16px",
              color: "white",
            }}
            // onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#E5E7EB"}
            // onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#FFF"}
          >
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

MenuDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired, // Controls visibility of the dropdown
  onClose: PropTypes.func.isRequired, // Callback to close the dropdown
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired, // Label for each item
      action: PropTypes.func.isRequired, // Action to execute on click
      className: PropTypes.string, // Optional custom class for each item
    })
  ).isRequired,
  className: PropTypes.string, // Optional custom class for the dropdown
};

export default MenuDropdown;